import { Component, OnInit } from '@angular/core';
import { NewsArticleSearchDto } from '../shared/dto/news-article-search.dto';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-news-articles-search',
  templateUrl: './news-articles-search.component.html',
  styleUrls: ['./news-articles-search.component.less'],
    standalone: false
})
export class NewsArticlesSearchComponent implements OnInit {
  searchParams = new NewsArticleSearchDto();
  constructor(private _navigationService: NavigationService) {}

  ngOnInit(): void {}

  navigateToArticlesSpa() {
    this._navigationService.navigateToArticlesSpa();
  }
}
